module.exports = __webpack_public_path__ + "static/assets/50a922b01833b9063fc5e97d24939bc8.png";